module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-home"
  }, [_c('div', {
    staticClass: "space-20"
  }), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(!_vm.loaded.skus || !_vm.loaded.productsMenu) ? _c('loading', {
    key: "loading"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loaded.skus && _vm.loaded.productsMenu),
      expression: "loaded.skus && loaded.productsMenu"
    }],
    key: "content",
    staticClass: "container"
  }, [_c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-double-right"
  }), _vm._v(" " + _vm._s(_vm.subcategory.name) + "\n      ")], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('list-products-menu', {
    attrs: {
      "subcategory-id": _vm.subcategoryId
    },
    on: {
      "loaded": _vm.loadedEvent
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('list-skus', {
    attrs: {
      "parent": "subcategory",
      "parent-id": _vm.subcategoryId
    },
    on: {
      "loaded": _vm.loadedEvent
    }
  })], 1)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-53fcf572!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageSubcategory.vue
// module id = 300
// module chunks = 1